export const CHANGE_PAGE_ID = "CHANGE_PAGE_ID";
export const CHANGE_LOGGED_IN = "CHANGE_LOGGED_IN";
export const CHANGE_SELECTED_PROJECT = "CHANGE_SELECTED_PROJECT";
export const CHANGE_SELECTED_BUILDING = "CHANGE_SELECTED_BUILDING";
export const CHANGE_SELECTED_FLOOR = "CHANGE_SELECTED_FLOOR";
export const CHANGE_OBSERVATION_HOUR = "CHANGE_OBSERVATION_HOUR";